import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthContext } from '../App';

export default function NavBar() {
  const { user, logout } = useAuthContext();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="bg-[#1A1D27] border-b border-gray-800 px-6 py-3 flex items-center justify-between">
      <div className="flex items-center gap-6">
        <Link to="/dashboard" className="flex items-center gap-2">
          <div className="w-8 h-8 bg-[#2563EB] rounded flex items-center justify-center">
            <span className="text-white text-xs font-bold font-mono">GC</span>
          </div>
          <span className="text-white font-semibold text-lg">Genesis Capital</span>
          <span className="text-gray-500 text-sm">LOS</span>
        </Link>
        <Link
          to="/dashboard"
          className="text-gray-400 hover:text-white text-sm transition-colors"
        >
          Loan Pipeline
        </Link>
      </div>

      <div className="flex items-center gap-4">
        {user && (
          <>
            <div className="flex items-center gap-2">
              <span className="text-gray-400 text-sm">{user.name}</span>
              <span className={`px-2 py-0.5 rounded text-xs font-mono font-medium ${user.role === 'admin'
                  ? 'bg-[#2563EB]/20 text-[#60A5FA] border border-[#2563EB]/30'
                  : 'bg-[#10B981]/20 text-[#34D399] border border-[#10B981]/30'
                }`}>
                {user.role === 'admin' ? 'Admin' : 'Originator'}
              </span>
            </div>
            <button
              onClick={handleLogout}
              className="text-gray-500 hover:text-gray-300 text-sm transition-colors"
            >
              Sign out
            </button>
          </>
        )}
      </div>
    </nav>
  );
}
